import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-265000c6")

_pushScopeId("data-v-265000c6")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "予約", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("予約の時間単位")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_box = _resolveComponent("select-box")
  const _component_vue_label = _resolveComponent("vue-label")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_vue_label, null, {
      label: _withId(() => [
        _hoisted_2
      ]),
      content: _withId(() => [
        _createVNode(_component_select_box, {
          items: _ctx.timeUnitOptions,
          modelValue: _ctx.appointmentTimeUnit,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.appointmentTimeUnit = $event))
        }, null, 8, ["items", "modelValue"])
      ]),
      _: 1
    })
  ]))
})